/**
 * containerStyle: Switch's containerStyle    object
 * labelStyle: Switch's labelStyle    object
 * value: Switch's value    state
 * onChange: Switch's onChange    function
 * name: Switch's name    string
 *
 */

import React from "react";

function BasicSwitch({ containerStyle, labelStyle, value, onChange, name }) {
	const inputRef = React.useRef();

	const ChangeToggle = (e) => {
		onChange(e);
	};

	return (
		<div className="switch-wrap" style={containerStyle}>
			<input
				className="switch-input"
				ref={inputRef}
				role={"switch"}
				type={"checkbox"}
				checked={value}
				onChange={ChangeToggle}
			/>
			<label
				className="switch-label"
				onClick={() => {
					onChange({
						target: { checked: !inputRef.current.checked },
					});
				}}
			>
				<span className="onf_btn"></span>
			</label>
			<label
				style={labelStyle}
				onClick={() => {
					onChange({
						target: { checked: !inputRef.current.checked },
					});
				}}
			>
				{name}
			</label>
		</div>
	);
}

BasicSwitch.defaultProps = {
	containerStyle: {},
	labelStyle: {
		margin: "0 5px",
		fontSize: "15px",
		fontFamily: "s-core-dream-Medium",
	},
};

export default BasicSwitch;
